import Navbar from "Components/Navbar/Navbar";
import SideNavBar from "Components/SideNavBar/SideNavBar";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function Layout({ children }) {
  const [openMobile, setOpenMobile] = useState(false);

  const { pathname } = useLocation();

  useEffect(() => {
    setOpenMobile(false);
  }, [pathname]);

  return (
    <div className="absolute z-50 inset-0 ">
      <div className="flex flex-col items-center gap-4 mx-auto h-[100vh] mt-0 mb-10">
        <div className="w-full h-full flex">
          <SideNavBar open={openMobile} setOpen={setOpenMobile} />
          <div className="flex-1 bg-background-secondary flex flex-col">
            <Navbar open={openMobile} setOpen={setOpenMobile} />
            <div className="border-l-2 border-border-darkNew flex-1 p-6 overflow-auto  ">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
